
import {Component, OnInit, Input, EventEmitter, Output, OnChanges, SimpleChange} from '@angular/core';

@Component({
  selector: 'nuc-pagination',
  templateUrl: './pagination.component.html',
  styleUrls: ['./pagination.component.scss']
})
export class PaginationComponent implements OnInit,OnChanges {

  @Input('maxSize') maxSize: number;
  @Input('pageSize') pageSize: number;
  @Input('totalCount') totalCount: number;
  @Input('boundaryLinks') boundaryLinks: boolean;
  @Input('currentPage') currentPage: number = 1;
  @Output('pageChanged') pageChanged: EventEmitter<any>  = new EventEmitter<any>();

  private pageList: Array<number> = [];
  private selectedPage: number;
  private nextItemValid: boolean = true;
  private previousItemValid: boolean = true;
  private nextItem: number = 2;
  private previousItem: number;

  constructor() { }

  ngOnInit() {
    this.doPaging();
  }

  ngOnChanges(changes: {[ propName: string]: SimpleChange}) {
   this.doPaging();
  }
  doPaging(){
    this.pageList = [];
    var i:number,count:number;
    this.selectedPage = this.currentPage;
    var remaining = this.totalCount % this.pageSize;
    var totalSize =((this.totalCount-remaining) / this.pageSize)+(remaining === 0 ? 0 : 1);
    for (i = (this.currentPage), count=0; i<= totalSize && count<this.maxSize; i++, count++) {
      this.pageList.push(i);
    }
    //next validation
    if(i-1<totalSize) {
      this.nextItemValid = true;
      this.nextItem = i;
    }else {
      this.nextItem = null;
      this.nextItemValid = false;
    }
    //previous validation
    if (this.currentPage > 1) {
      this.previousItemValid = true;
    }else {
      this.previousItemValid = false;
    }
  }

  nextPage(nextItem){
    this.setCurrentPage(nextItem);
  }

  firstPage(){
   this.setCurrentPage(1);
  }

  previousPage(nextItem){
    let nextPage;
    if (!nextItem){
      if ((this.currentPage - this.maxSize) > 0)
           nextPage = this.currentPage - this.maxSize;
      else
           nextPage = this.currentPage - 1;
      this.setCurrentPage(nextPage);
      return;
    }
    if ((nextItem - 2 *  this.maxSize) > 0){
      nextPage = (nextItem - 2 *this.maxSize);
    }
    else{
      nextPage = this.currentPage - 1;
    }
    this.setCurrentPage(nextPage);

  }

  setCurrentPage(pageNo){
   this.currentPage = pageNo;
   this.doPaging();
   this.pageChangeListener();
  }

  lastPage() {
    var totalPages = Math.floor(this.totalCount / this.pageSize);
    var lastPage = this.totalCount % this.pageSize === 0 ? totalPages: totalPages +1;
    this.setCurrentPage(lastPage);
  }


  pageChangeListener() {
    this.pageChanged.emit({
      page: this.currentPage
    });
  }
}




// WEBPACK FOOTER //
// ./src/app/shared/pagination/pagination.component.ts